






import { createComponent } from "@vue/composition-api";

interface Props {
  errors: {
    [fieldName: string]: string;
  };
}

export default createComponent<Props>({
  components: {},
  props: {
    errors: { required: false },
  },
  setup(props, ctx) {
    return {};
  },
});
